import type { Component } from 'vue';
import { PUI } from '@pleased-npm/fe-customisation';
import ConversationsIcon from '../icons/ConversationsIcon.vue';
import ArticlesIcon from '../icons/ArticlesIcon.vue';
import StatusIcon from '../icons/StatusIcon.vue';
import NewConvoIcon from '../icons/NewConvoIcon.vue';
import HelpIcon from '../icons/HelpIcon.vue';

/**
 * Map of navigation action types to their corresponding icon components
 */
export const ACTION_ICON_MAP: Record<string, Component> = {
  [PUI.NAVIGATION_ACTIONS.GO_TO_CONVERSATIONS]: ConversationsIcon,
  [PUI.NAVIGATION_ACTIONS.GO_TO_STATUS]: StatusIcon,
  [PUI.NAVIGATION_ACTIONS.GO_TO_ARTICLES]: ArticlesIcon,
  [PUI.NAVIGATION_ACTIONS.NEW_CONVERSATION]: NewConvoIcon,
  [PUI.NAVIGATION_ACTIONS.GO_TO_HELP_CENTER]: HelpIcon,
} as const;

export enum NavigationAction {
  OPEN_WIDGET = 'open-widget',
}

/**
 * Map of navigation action types to their corresponding route paths
 */
export const ACTION_LINK_MAP: Record<string, { path?: string; action?: NavigationAction }> = {
  [PUI.NAVIGATION_ACTIONS.GO_TO_CONVERSATIONS]: { path: '/conversations' },
  [PUI.NAVIGATION_ACTIONS.GO_TO_STATUS]: { path: '/status' },
  [PUI.NAVIGATION_ACTIONS.GO_TO_ARTICLES]: { path: '/new-help' },
  [PUI.NAVIGATION_ACTIONS.GO_TO_HELP_CENTER]: { path: '/new-help' },

  [PUI.NAVIGATION_ACTIONS.NEW_CONVERSATION]: { action: NavigationAction.OPEN_WIDGET },
} as const;
